var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"account"},[_c('Header',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('el-table',{ref:"orderTable",staticClass:"order-table table no-border-table",attrs:{"data":_vm.accountList,"header-cell-style":{
          border: 'none',
          color: '#333',
          background: '#f6f6f6',
          borderBottom: '1px solid #E8E8E8',
          height: '54px',
        },"row-style":{
          height: '54px',
        }}},[_c('el-table-column',{attrs:{"prop":"nickname","label":"昵称"}}),_c('el-table-column',{attrs:{"prop":"username","label":"账号"}}),_c('el-table-column',{attrs:{"prop":"phone","label":"手机号"}})],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }